// extracted by mini-css-extract-plugin
module.exports = {"infoForm":"_3WVZbhyxt-Ska7AE6etwJy"};